import { TicketSelectorOption, TicketType } from '@nx-ng/types';

export const translationMap: { [T in TicketType]: TicketSelectorOption } = {
  ticketOrPass: {
    titleKey: 'selector_tickets_and_passes_title',
    descriptionKey: 'selector_tickets_and_passes_description',
  },
  flexible: {
    titleKey: 'selector_flexible_title',
    descriptionKey: 'selector_flexible_description',
  },
  payAsYouGo: {
    titleKey: 'selector_pay_as_you_go_title',
    descriptionKey: 'selector_pay_as_you_go_description',
  },
};
